import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
}

export function Loader({ className, size = 16, ...props }: LoaderProps) {
  const { t } = useTranslation();

  return (
    <div role="status" className={cn("animate-spin", className)} {...props}>
      <Loader2 size={size} />
      <span className="sr-only">{t("loading")}</span>
    </div>
  );
}
